<div fxLayout>
  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="yourplan__hero">
      <sbnb-your-plan-hero-item context="negative">
        Your subscription has expired. Please contact the primary user on the account to activate a subscription so you
        can continue to use Hospitable.
      </sbnb-your-plan-hero-item>
    </div>
  </main>
</div>
